import SystemSettingContainer from 'views/pages/system-setting/SystemSettingContainer';

export default SystemSettingContainer;
